export default __webpack_public_path__ + "static/media/KHL_WHITE.d8e3140f.png";